import { red, grey as muiGrey, green, amber, common } from '@mui/material/colors';

import { PaletteThemeProps } from '@/@mantis/types/theme';

export default function TerraiTheme(): PaletteThemeProps {
  return {
    primary: {
      0: '#FFF4F3',
      lighter: '#FFF4F3',
      100: '#FFE5E2',
      200: '#FFD6D1',
      light: '#DA8578',
      400: '#C46A5C',
      main: '#9D1500', // main logo color
      dark: '#190302',
      700: '#130202',
      darker: '#0D0101',
      900: '#070101',
      contrastText: common.white,
    },
    secondary: {
      lighter: muiGrey[50], // box and top bar background color
      100: muiGrey[100], // all background colors
      200: muiGrey[200], // hover color
      light: muiGrey[300],
      400: muiGrey[400], // hover border color
      main: muiGrey[500],
      600: muiGrey[600], // sidebar icon color
      dark: muiGrey[700], // sidebar text color
      800: muiGrey[800],
      darker: muiGrey[900], // sidebar text color
      A100: muiGrey[900],
      A200: muiGrey[400],
      A300: muiGrey[300],
      contrastText: common.white,
    },
    error: {
      0: red[50],
      lighter: red[100],
      light: red[300],
      main: red[500],
      dark: red[600],
      darker: red[900],
      contrastText: common.white,
    },
    warning: {
      lighter: amber[50],
      light: amber[300],
      main: amber[500],
      dark: amber[600],
      darker: amber[900],
      contrastText: common.white,
    },
    info: {
      lighter: muiGrey[50],
      light: muiGrey[300],
      main: muiGrey[500],
      dark: muiGrey[600],
      darker: muiGrey[900],
      contrastText: common.white,
    },
    success: {
      lighter: green[50],
      light: green[300],
      main: green[500],
      dark: green[600],
      darker: green[900],
      contrastText: common.white,
    },
    grey: {
      0: muiGrey[50],
      50: muiGrey[50],
      100: muiGrey[100],
      200: muiGrey[200],
      300: muiGrey[300],
      400: muiGrey[400],
      500: muiGrey[500],
      600: muiGrey[600],
      700: muiGrey[700],
      800: muiGrey[800],
      900: muiGrey[900],
      A50: muiGrey[50],
      A100: muiGrey[900],
      A200: muiGrey[400],
      A400: muiGrey[200],
      A700: muiGrey[100],
      A800: muiGrey[500],
    },
  };
}
